import { z } from 'zod';
import { UUIDSchema } from '../domain/models';

export const Themes = ['light', 'dark', 'contrast-dark', 'system'] as const;

export const ThemeSchema = z.enum(Themes);

export type UserPreferenceTheme = z.infer<typeof ThemeSchema>;

const BaseItemSchema = z.object({
  pushTokens: z.array(z.string()).optional(),
  theme: ThemeSchema.optional(),
  wards: z.array(z.string()),
});

export const UserPreferenceItemSchema = BaseItemSchema.extend({
  pk: z.string(),
});

/**
 * @deprecated use pk instead
 */
export const PreferenceItemSchema = BaseItemSchema.extend({
  userReference: z
    .string()
    .describe('This field is deprecated, use pk instead'),
});

export const UserPreferenceWardSchema = z.object({
  id: UUIDSchema,
  name: z.string(),
});

export type PreferenceItem = z.infer<typeof PreferenceItemSchema>;

export type Item = PreferenceItem;

export interface UserPreferencePushTokenChangeRequest {
  userReference: string;
  pushToken: string;
}

export interface UserPreferenceGetPreferenceRequest {
  userReference: string;
}
export type UserPreferenceGetPreferenceResponse = Item | undefined;

export interface UserPreferenceGetPreferencesRequest {
  userReferences: string[];
}
export type UserPreferenceGetPreferencesResponse = Item[];

export type UserPreferenceUpdatePreferenceRequest = Omit<Item, 'pushTokens'>;
export type UserPreferenceUpdatePreferenceResponse = Item;
export type UserPreferenceWard = z.infer<typeof UserPreferenceWardSchema>;
